import { render, staticRenderFns } from "./FundFlowPage.vue?vue&type=template&id=0cbc8d34&scoped=true"
import script from "./FundFlowPage.vue?vue&type=script&lang=js"
export * from "./FundFlowPage.vue?vue&type=script&lang=js"
import style0 from "./FundFlowPage.vue?vue&type=style&index=0&id=0cbc8d34&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc8d34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cbc8d34')) {
      api.createRecord('0cbc8d34', component.options)
    } else {
      api.reload('0cbc8d34', component.options)
    }
    module.hot.accept("./FundFlowPage.vue?vue&type=template&id=0cbc8d34&scoped=true", function () {
      api.rerender('0cbc8d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fundFlow/FundFlowPage.vue"
export default component.exports